/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetFinishedCattleMarketPricesQueryResponse, GetFinishedCattleMarketPricesPathParams, GetFinishedCattleMarketPricesQueryParams, GetFinishedCattleMarketPrices400, GetFinishedCattleMarketPrices401, GetFinishedCattleMarketPrices403, GetFinishedCattleMarketPrices404, GetFinishedCattleMarketPrices409, GetFinishedCattleMarketPrices500, GetFinishedCattleMarketPrices503 } from "../../types/marketPricesController/GetFinishedCattleMarketPrices.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetFinishedCattleMarketPricesUrl(organizationId: GetFinishedCattleMarketPricesPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/market-prices/finished-cattle` as const }
  return res
}

/**
 * @summary The published finished-cattle quote (R$/@) for each state the organization's farms are in (optionally one farm via ?establishmentId), plus every other covered state
 * {@link /api/organizations/:organizationId/market-prices/finished-cattle}
 */
export async function getFinishedCattleMarketPrices(organizationId: GetFinishedCattleMarketPricesPathParams["organizationId"], params?: GetFinishedCattleMarketPricesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetFinishedCattleMarketPricesQueryResponse, ResponseErrorConfig<GetFinishedCattleMarketPrices400 | GetFinishedCattleMarketPrices401 | GetFinishedCattleMarketPrices403 | GetFinishedCattleMarketPrices404 | GetFinishedCattleMarketPrices409 | GetFinishedCattleMarketPrices500 | GetFinishedCattleMarketPrices503>, unknown>({ method : "GET", url : getGetFinishedCattleMarketPricesUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}